'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitForgotPassword = exports.getUiForgotPassword = exports.FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var FORGOT_PASSWORD_FAIL = exports.FORGOT_PASSWORD_FAIL = 'la/ui/forgotPassword/FAIL';
var FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_REQUEST = 'la/ui/forgotPassword/REQUEST';
var FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_SUCCESS = 'la/ui/forgotPassword/SUCCESS';

// reducer
var DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: false,
                errorMessage: null,
                submitted: true,
                success: false
            });
        case FORGOT_PASSWORD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                submitted: false,
                success: true
            });
        case FORGOT_PASSWORD_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.forgotPassword;
};

var getUiForgotPassword = exports.getUiForgotPassword = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
var submitForgotPassword = exports.submitForgotPassword = function submitForgotPassword(emailAddress) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: emailAddress,
                                type: FORGOT_PASSWORD_REQUEST
                            });
                            _context.next = 7;
                            return _api.Auth.postForgotPassword({ authToken: authToken, deployment: deployment, emailAddress: emailAddress });

                        case 7:
                            dispatch({
                                payload: emailAddress,
                                type: FORGOT_PASSWORD_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { emailAddress: emailAddress },
                                payload: _context.t0,
                                type: FORGOT_PASSWORD_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/forgotPassword.js
// module id = vOFV
// module chunks = 57